var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDocSelectorIdSelected = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 8.00003H6C4.89543 8.00003 4 8.89546 4 10V38C4 39.1046 4.89543 40 6 40H42C43.1046 40 44 39.1046 44 38V10C44 8.89546 43.1046 8.00003 42 8.00003Z",
    stroke: "#A12885",
    strokeWidth: 1.41106,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 24.9999C19.2091 24.9999 21 23.209 21 20.9999C21 18.7908 19.2091 16.9999 17 16.9999C14.7909 16.9999 13 18.7908 13 20.9999C13 23.209 14.7909 24.9999 17 24.9999Z",
    stroke: "#A12885",
    strokeWidth: 1.41106,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.001 31C23.001 27.6863 20.3147 25 17.001 25C13.6873 25 11.001 27.6863 11.001 31",
    stroke: "#A12885",
    strokeWidth: 1.41106,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.001 19.9999H36.001",
    stroke: "#A12885",
    strokeWidth: 1.41106,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30 27.9999H36",
    stroke: "#A12885",
    strokeWidth: 1.41106,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDocSelectorIdSelected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/doc-selector-id-selected.1b93f3991f9e32fc0d05deb827688865.svg";